import { useEffect, useRef, useState } from 'react';
import { useUnit } from 'effector-react';
import { t } from 'i18next';
import { Badge, ClickAwayListener, IconButton, Tooltip } from '@mui/material';
import VerticalAlignTopOutlinedIcon from '@mui/icons-material/VerticalAlignTopOutlined';
import { ThemeAdapter } from '@shared/theme/adapter';
import {
  $getBadgeColorAndNumber,
  $notReadImports,
  $openImportsPopperCounter,
  $processingImports,
  ImportTemporalGate,
} from '../model';
import { Toast } from '../model/toast/ui';
import { ImportPopper } from './components/popper';
import * as Styled from './styled';

export const ExportTemporal = () => (
  <ThemeAdapter>
    <ExportTemporalBody />
  </ThemeAdapter>
);

export const ExportTemporalBody = () => {
  const [importPopperOpened, setImportPopperOpened] = useState(false);
  const iconButtonRef = useRef<HTMLButtonElement | null>(null);
  const [
    openImportsPopperCounter,
    getBadgeColorAndNumber,
    processingImports,
    notReadImports,
  ] = useUnit([
    $openImportsPopperCounter,
    $getBadgeColorAndNumber,
    $processingImports,
    $notReadImports,
  ]);

  const toggleImportPopperOpened = () => {
    setImportPopperOpened((prev) => !prev);
  };

  useEffect(() => {
    if (!openImportsPopperCounter) return;

    setImportPopperOpened(true);
  }, [openImportsPopperCounter]);

  return (
    <>
      <ImportTemporalGate />

      {!!notReadImports.length && (
        <ClickAwayListener onClickAway={() => setImportPopperOpened(false)}>
          <div>
            <Toast />

            <Tooltip title={importPopperOpened ? undefined : t('export')}>
              <IconButton onClick={toggleImportPopperOpened} ref={iconButtonRef}>
                <Badge
                  badgeContent={getBadgeColorAndNumber.number}
                  color={getBadgeColorAndNumber.color}
                >
                  <VerticalAlignTopOutlinedIcon />
                </Badge>
              </IconButton>
            </Tooltip>

            {!!processingImports.length && <Styled.LinearProgress />}

            <ImportPopper
              anchorEl={importPopperOpened ? iconButtonRef.current : null}
              setImportPopperOpened={setImportPopperOpened}
            />
          </div>
        </ClickAwayListener>
      )}
    </>
  );
};
